﻿function executeScriptElements($container, callBack) {
	const scriptElements = $container.querySelectorAll("script");

	Array.from(scriptElements).forEach((scriptElement) => {
		const clonedElement = document.createElement("script");

		Array.from(scriptElement.attributes).forEach((attribute) => {
			clonedElement.setAttribute(attribute.name, attribute.value);
		});
		clonedElement.text = scriptElement.text;

		scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
		clonedElement.onload = () => {
			callBack();
		};
	});
}

export { executeScriptElements };
